export interface Options {
	totalUsersCompliant?: number;
	totalUsersObserved?: number;
}

const totalUsersCompliantPercentage = ({
	totalUsersCompliant,
	totalUsersObserved
}: Options) => {
	if (totalUsersCompliant === undefined || totalUsersObserved === undefined)
		return;

	const { format } = new Intl.NumberFormat("en-GB", { style: "percent" });
	const value = totalUsersCompliant / totalUsersObserved;

	if (isNaN(value)) {
		return "0%";
	}

	const percentage = format(value);

	return percentage;
};

export default totalUsersCompliantPercentage;
